/**
 * FormHandler クラスは、フォームの動作を制御するためのメソッドを提供。
 * 主に、送信ボタンの無効化、同意確認、メールアドレスの確認、および送信後のリダイレクトを扱います。
 */
export class FormHandler {
	/**
	 * コンストラクタは、フォームの初期化メソッドを呼び出す。
	 */
	constructor() {
		// Contact Form 7 のフォーム要素を取得
		this.wpcf7Elm = document.querySelector('.wpcf7-form');

		// フォームが存在しない場合は処理を終了
		if (!this.wpcf7Elm) return;

		// フォームの初期化処理を実行
		this.init();
	}

	/**
	 * フォームの動作を初期化するためのメソッド。
	 * 送信ボタンの無効化、同意チェックの監視、メール確認、送信後のリダイレクトを設定。
	 */
	init() {
		this._disableSubmitButton();     // 初期状態で送信ボタンを無効化
		this._handleConsentChange();     // 同意チェックボックスの動作を設定
		// this._checkEmailConfirmation(); // メールアドレス確認（必要時のみ有効化）
		this._redirectOnSuccess();       // 送信成功後のリダイレクト処理を設定
	}

	/**
	 * 送信ボタンを初期状態で無効化する。
	 */
	_disableSubmitButton() {
		$('.wpcf7-submit').prop('disabled', true);
	}

	/**
	 * 同意チェックボックスの変更を監視し、
	 * チェックされていれば送信ボタンを有効化、外せば無効化。
	 * また、アクセシビリティ向けに aria-checked 属性も更新。
	 */
	_handleConsentChange() {
		$('.js-consent').off().on('change', () => {
			const isChecked = $('.js-consent').prop('checked');
			$('.wpcf7-submit').prop('disabled', !isChecked);
			$('.js-consent').attr('aria-checked', isChecked);
		});
	}

	/**
	 * （未使用：コメントアウト中）
	 * メールアドレスと確認用メールアドレスが一致するかをチェック。
	 * 一致しない場合はエラーメッセージを表示し、送信をキャンセル。
	 */
	_checkEmailConfirmation() {
		this.wpcf7Elm.addEventListener('submit', function (event) {
			event.preventDefault(); // デフォルトの送信を一旦キャンセル
			const email = $('.wpcf7-email').val();
			const emailConfirm = $('.js-email-confirm').val();

			// メールアドレス不一致の場合
			if (email !== emailConfirm) {
				const $errorMessage = $('<div role="alert">メールアドレスが一致しません</div>');
				$('.js-email-confirm').after($errorMessage).attr('aria-invalid', 'true');
				return false;
			} else {
				// 一致する場合はエラー解除
				$('.js-email-confirm').attr('aria-invalid', 'false');
			}
		});
	}

	/**
	 * フォーム送信成功時の処理。
	 * - 送信ボタンを無効化
	 * - ボタンを半透明に変更し「送信中...」に文言変更
	 * - アクセシビリティ対応（aria-live）
	 * - サンクスページにリダイレクト
	 */
	_redirectOnSuccess() {
		this.wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
			event.preventDefault(); // デフォルトの遷移処理をキャンセル
			$('.wpcf7-submit').css({
				pointerEvents: 'none', // ボタンを押せない状態にする
				opacity: '0.5',       // 半透明にして送信中を表現
			}).val('送信中...').attr('aria-live', 'assertive');

		const resourceId = $(event.target).find('input[name="resource-id"]').val();

          if (resourceId) {
            // --- 【資料ダウンロードの場合】 ---
            // 中継用URLを生成して別タブで開く
            const downloadUrl = window.location.origin + '/?download_id=' + resourceId;
            location.href = downloadUrl;
            $('.wpcf7-submit').val('申し込みが完了しました').css({
              pointerEvents: 'none',
              opacity: '0.5'
            });
            
          } else {
			// サンクスページにリダイレクト
			location.href = '/contact-thanks/';
		}});
	}
}